import useSWRV from 'swrv'
import fetcher from '@/lib/API/fetcher'

export default () => {
    const { data: riders, error } = useSWRV('/user/teams/riders?all=1', fetcher)

    return { riders, error }
}
